import { BaseControlBehaviour } from './Behaviours/BaseControlBehaviour';

declare var Inputmask: Function;

window.ControlshandleGrecaptchaLoaded = function() {
    Controls.continueConfiguring();
}

interface IControlTypeDefinitions {
    inputMask?: any;
    tooltip?: any;

}
interface IControlsOptions {
    useRecaptcha?: boolean;
    types?: IControlTypeDefinitions;
    requiredBehaviors?: string[];
}

var Controls = window.Controls = (function () {
    var options: IControlsOptions;
    let behaviours: BaseControlBehaviour[] = [];
    var requiredBehaviors: {};

    function configure(opts?: IControlsOptions) {
        if (typeof Behaviours.ReplaceTagBehaviour === 'function') behaviours.push(new Behaviours.ReplaceTagBehaviour());
        if (typeof Behaviours.InputMaskBehaviour === 'function') behaviours.push(new Behaviours.InputMaskBehaviour());
        if (typeof Behaviours.InputTrimBehaviour === 'function') behaviours.push(new Behaviours.InputTrimBehaviour());
        if (typeof Behaviours.DatePickerBehaviour === 'function') behaviours.push(new Behaviours.DatePickerBehaviour());
        if (typeof Behaviours.PagerBehaviour === 'function') behaviours.push(new Behaviours.PagerBehaviour());
        if (typeof Behaviours.PagerTriggerBehaviour === 'function') behaviours.push(new Behaviours.PagerTriggerBehaviour());
        if (typeof Behaviours.TabsBehaviour === 'function') behaviours.push(new Behaviours.TabsBehaviour());
        if (typeof Behaviours.TooltipsBehaviour === 'function') behaviours.push(new Behaviours.TooltipsBehaviour());
        if (typeof Behaviours.RecaptchaBehaviour === 'function') behaviours.push(new Behaviours.RecaptchaBehaviour());
        if (typeof Behaviours.PasswordPreviewBehaviour === 'function') behaviours.push(new Behaviours.PasswordPreviewBehaviour());
        if (typeof Behaviours.SortableBehaviour === 'function') behaviours.push(new Behaviours.SortableBehaviour());
        if (typeof Behaviours.ChangablesBehaviour === 'function') behaviours.push(new Behaviours.ChangablesBehaviour());
        if (typeof Behaviours.CustomSelectsBehaviour === 'function') behaviours.push(new Behaviours.CustomSelectsBehaviour());
        if (typeof Behaviours.AutoFocusBehaviour === 'function') behaviours.push(new Behaviours.AutoFocusBehaviour());
        if (typeof Behaviours.EnterBehaviour === 'function') behaviours.push(new Behaviours.EnterBehaviour());
        if (typeof Behaviours.AjaxActionBehavior === 'function') behaviours.push(new Behaviours.AjaxActionBehavior());
        if (typeof Behaviours.ToggleBehaviour === 'function') behaviours.push(new Behaviours.ToggleBehaviour());
        if (typeof Behaviours.ComponentBehavior === 'function') behaviours.push(new Behaviours.ComponentBehavior());
        if (typeof Behaviours.NotificationBehaviour === 'function') behaviours.push(new Behaviours.NotificationBehaviour());
        if (typeof Behaviours.WidgetBehavior === 'function') behaviours.push(new Behaviours.WidgetBehavior());
        if (typeof Behaviours.ScrollbarBehaviour === 'function') behaviours.push(new Behaviours.ScrollbarBehaviour());
        if (typeof Behaviours.UseBettingCartBehaviour === 'function') behaviours.push(new Behaviours.UseBettingCartBehaviour());
        if (typeof Behaviours.AddressesTableBehaviour === 'function') behaviours.push(new Behaviours.AddressesTableBehaviour());
        if (typeof Behaviours.PaymentChannelAmountBehaviour === 'function') behaviours.push(new Behaviours.PaymentChannelAmountBehaviour());
        if (typeof Behaviours.VoximplantCallBehaviour === 'function') behaviours.push(new Behaviours.VoximplantCallBehaviour());
        if (typeof Behaviours.CustomFileBehaviour === 'function') behaviours.push(new Behaviours.CustomFileBehaviour());
        options = opts || {};

        var behaviorsToInstall;
        if (!!options.requiredBehaviors) {
            behaviorsToInstall = options.requiredBehaviors;
        }
        else {
            behaviorsToInstall = ['*'];

        }

        setRequiredBehaviors.apply(behaviorsToInstall, behaviorsToInstall);

        configureDefaultOptions();

        if (options.useRecaptcha) {
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://www.google.com/recaptcha/api.js?render=explicit&onload=ControlshandleGrecaptchaLoaded&hl=ru";
            s.async = true;
            s.defer = true;

            $("body").append(s);
        }
        else {
            continueConfiguring();
        }
    }

    function setRequiredBehaviors() {
        requiredBehaviors = {};
        for (var i = 0; i < arguments.length; i++) {
            var b = arguments[i];
            if (b == '*') {
                requiredBehaviors = {};
                for (var j = 0; j < behaviours.length; j++) {
                    requiredBehaviors[behaviours[j].getBehaviorName()] = true;
                }

                return;
            }
            else {
                requiredBehaviors[b] = true;
            }
        }
    }

    function configureDefaultOptions() {
        options.types = $.extend(true, {}, options.types || {});
        options.types.inputMask = $.extend(true, {}, options.types.inputMask || {});
        options.types.tooltip = $.extend(true, {}, options.types.tooltip || {});
    }

    function detectSelector(element: any) {
        if (!element) return null;
        if (typeof (element) == 'string') return { selector: element, type: 'css' }; //css Selector

        if (typeof (element) == 'object') {
            if (element.Selector && element.Html) return { selector: element.Selector, type: 'ajax', view: element }; // IAjaxView

            return { selector: element, type: 'html' };//вероятно HTML Element
        }

        return null;
    }

    function parse(element: any) {
        var selector = detectSelector(element);
        if (!selector) return;
        var shouldInstall = selector.type == 'css'
            || selector.type == 'html'
            || (selector.type == 'ajax' && !selector.view.OmitControlsInitialization);

        if (shouldInstall) {
            var elements = $('*', selector.selector);
            for (let i = 0; i < behaviours.length; i++) {
                let b = behaviours[i];
                if (requiredBehaviors[b.getBehaviorName()]) {
                    for (var elementIndex = 0; elementIndex < elements.length; elementIndex++) {
                        var elementToCheck = elements[elementIndex];

                        if (b.shouldInstall(elementToCheck)) {
                            b.install(elementToCheck, options);
                        }
                    }
                }
            }

            Validators.parse(selector.selector);
        }
    }

    function parseOne(element: HTMLElement, controlBehaviour: Behaviours.BaseControlBehaviour) {
        var selector = detectSelector(element);
        if (!selector) return;
        var shouldInstall = selector.type == 'css'
            || selector.type == 'html'
            || (selector.type == 'ajax' && !selector.view.OmitControlsInitialization);

        if (shouldInstall) {
            var elements = $('*', selector.selector);
            if (requiredBehaviors[controlBehaviour.getBehaviorName()]) {
                for (var elementIndex = 0; elementIndex < elements.length; elementIndex++) {
                    var elementToCheck = elements[elementIndex];
                    if (controlBehaviour.shouldInstall(elementToCheck)) {
                        controlBehaviour.install(elementToCheck, options);
                    }
                }
            }
            Validators.parse(selector.selector);
        }
    }

    function continueConfiguring() {
        Ajax.addAjaxViewParser((view) => {
            if (Controls) {
                Controls.parse(view);
            }
        }, 'default');

        Validators.init();

        parse(document);
    }

    return {
        configure,
        setRequiredBehaviors,
        parse,
        parseOne,
        continueConfiguring
    }
}())